// extracted by mini-css-extract-plugin
export default {"main":"Scenarios_main__sLLmX","item":"Scenarios_item__nKL0k","title":"Scenarios_title__x3QdP","caption":"Scenarios_caption__h5N5O","image":"Scenarios_image__2cJx8"};